import {request} from "@/shared/api/http";

import {ContextCompany, UserProfile} from "@/entities/User/model/types";

import {IOfferDTO} from "@/entities/User/api/types";

export const getUserProfile = async (): Promise<UserProfile> => {
    return (await request.get(`/proxy/profile-api.bpmn/api/v1/profile/user`)).data;
}

export async function getCompanies(): Promise<ContextCompany[]> {
    return (await request.get('/proxy/ismet-docs-api.ismet-docs/api/v1/user/main-company')).data;
}

export const getAvatar = async () => {
    const data = (await request.get(`/proxy/profile-api.bpmn/api/v1/profile/avatar`, {responseType: 'blob'})).data;
    if (!data.size) {
        return null;
    }
    return URL.createObjectURL(data);
}

export const logOut = async () => {
    return await request.get(`/proxy/account-recovery-api.bpmn/auth/logout`);
}

export const saveUserLocale = async (locale: string): Promise<any> => {
    return await request.post(`/proxy/profile-api.bpmn/api/v1/user-entity/set-locale/${locale}`, {})
}

export async function acceptOffer(uin: string) {
    return await request.post(`/proxy/ismet-docs-api.ismet-docs/api/v1/consent/accept-offer/${uin}`);
}

export async function getOfferStatus(uin: string): Promise<IOfferDTO> {
    return (await request.get(`/proxy/ismet-docs-api.ismet-docs/api/v1/consent/${uin}`)).data;
}
